<template>
    <div class="my-comment" v-if="comment">
        <div class="my-comment__answer">
            <CharMessage :object="comment"/>
        </div>
        <div class="my-comment__comment">
            <MyCharComment :object="comment.comment" />
        </div>
        
    </div>
</template>

<script>
import CharMessage from '@/components/course/CharMessage';
import MyCharComment from './MyCharComment';

export default {
    props: ['comment'],
    components:{
        CharMessage, 
        MyCharComment
    }
}
</script>

<style lang="scss" scoped>
.my-comment{
    &__answer{
        margin-bottom: 2rem;
    }
    &__comment{
        margin-bottom: 1rem;
    }
    padding: 10px 20px;
    width: 85%;
}
</style>